import { useEffect } from "react";

export default function useMakeScrollable(selector=".scrollable") {
  useEffect(() => {
    const wrapper = document.querySelector(selector);
    if (!wrapper) return;

    wrapper.addEventListener(
      "touchmove",
      function(event) {
        event.stopPropagation();
      },
      false
    );
  });
}
